import { render } from "./stronaNewsletter.vue?vue&type=template&id=4eb22d4b&scoped=true"
const script = {}

import "./stronaNewsletter.vue?vue&type=style&index=0&id=4eb22d4b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eb22d4b"]])

export default __exports__